var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-modal-body"},[_c('h3',{staticClass:"text-center mb-4"},[_vm._v(_vm._s(_vm.name))]),(_vm.id)?_c('app-establishment-search-section',{key:'s' + _vm.id,attrs:{"data-id":_vm.id}}):_vm._e(),(_vm.id)?_c('app-establishment-bind-section',{key:'b' + _vm.id,attrs:{"data-id":_vm.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }